<template>
  <div class="message">
    <div class="content">
      <div class="card">
        <div class="menu">
          <div class="title" :class="{active:page === 'platform'}" @click="changeTitle('platform')">平台消息</div>
          <div class="title" :class="{active:page === 'system'}" @click="changeTitle('system')">系统消息</div>
        </div>
        <div class="platform" v-if="page === 'platform'">
          <div class="" v-loading="loading">
            <MessageItem :title="item.title" :desc="item.outline" :time="item.created_at" :image="item.thumbnail" @click="clickDetail(item.id)"
              v-for="(item,i) in platform"></MessageItem>
            <el-empty :image-size="120" v-if="platform.length==0"></el-empty>
            <PageComponents :total="tableShow.listCount" :current="tableShow.currentPage" :pageSize="tableShow.pageSize"
              @on-change="changePage"></PageComponents>
          </div>
        </div>

        <div class="system" v-if="page === 'system'">
          <div class="" v-loading="loading">
            <MessageItem :is-link="!!item.order_id" :title="item.title" :desc="item.instruction" :time="item.created_at" @click="clickOrderDetail(item.order_id)"
              v-for="(item,i) in orders"></MessageItem>
            <el-empty :image-size="120" v-if="orders.length==0"></el-empty>
            <PageComponents :total="orderShow.listCount" :current="orderShow.currentPage" :pageSize="orderShow.pageSize"
              @on-change="changePageOrder"></PageComponents>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponents from '../../components/header'
import PageComponents from '../../components/page'
import MessageItem from './components/message-item'

export default {
  name: 'setting',
  components: {
    MessageItem,
    HeaderComponents,
    PageComponents
  },
  created () {
    let vm = this
    vm.getPlatform()
  },
  data () {
    return {
      tableShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      loading: true,
      orderShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      platform: [],
      orders: [],
      page: 'platform'
    }
  },
  methods: {
    getPlatform () {
      let vm = this
      this.$request('611a21175edc3', {
        page: vm.tableShow.currentPage,
        limit: vm.tableShow.pageSize
      }).then(res => {
        vm.tableShow.listCount = res.data.data.count
        vm.platform = []
        console.log(vm.tableShow.listCount)
        res.data.data.list.forEach(function (it) {
          vm.platform.push({
            'id': it.id,
            'outline': it.outline,
            'title': it.title,
            'created_at': it.created_at,
            'thumbnail': it.thumbnail
          })
        })
        this.loading = false
      })
    },
    getOrders () {
      let vm = this
      return this.$request('61829272b3fad', {
        page: vm.orderShow.currentPage,
        limit: vm.orderShow.pageSize
      }).then(res => {
        vm.orderShow.listCount = res.data.count
        vm.orders = []
        console.log(vm.tableShow.listCount)
        res.data.data.forEach(function (it) {
          vm.orders.push({
            'id': it.id,
            'title': it.title,
            'created_at': it.created_at,
            'instruction': it.instruction,
            'order_id': it.order_id,
            'order_num': it.order_num,
            'product': it.product,
            'service': it.service
          })
        })
        this.loading = false
        this.$root.$emit('refresh-message-count')
      })
    },
    changePageOrder (page) {
      this.loading = true
      this.orderShow.currentPage = page
      this.getOrders()
    },
    changePage (page) {
      this.loading = true
      this.tableShow.currentPage = page
      this.getPlatform()
    },
    changeTitle (title) {
      this.page = title
      this.loading = true
      if (title == 'platform') {
        this.getPlatform()
      } else {
        this.getOrders()
      }
    },
    clickOrderDetail (orderId) {
      if (!orderId) return
      this.$router.push({
        name: 'order_detail',
        params: { id: orderId }
      })
    },
    clickDetail (id) {
      console.log(id)
      this.$router.push({
        name: 'message_detail',
        params: {
          id: id
        }
      })
    }
  }
}
</script>

<style lang="less">
  .message {
    .ivu-steps-title {
      margin-top: 2px;
    }

    .content {
      background-color: #f7f8fa;
    }

    .card {
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 3px;

      .menu {
        display: flex;

        .title {
          font-size: 18px;
          color: #333;
          position: relative;
          margin-right: 30px;
          cursor: pointer;

        }

        .active {
          font-weight: 450;

          &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0;
            width: 70px;
            height: 3px;
            background-color: #FB9E2F;
          }
        }
      }

      .platform,
      .system {
        margin-top: 40px;
      }
    }
  }
</style>
